<template>
  <div>
    <registros-modal />
    <section role="modal">
      <div
        class="modal fade"
        id="bemVindoModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="bemVindoModalLabel"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title" id="bemVindoModalLabel">
                Meu Primeiro Acesso
              </h4>
            </div>
            <div class="modal-body">
              <div class="row row-field" style="padding-bottom: 15px">
                <div class="col-md-12 col-sm-12">
                  <p style="text-align: justify">
                    Seja bem-vindo à
                    <strong>Central do Servidor</strong>. Aqui centralizamos as
                    informações da sua vida profissional na Prefeitura. Escolha
                    um <strong>item do menu</strong> e tenha acesso à informação
                    que precisar.
                  </p>
                  <p style="text-align: justify">
                    Ao centro você tem os links mais clicados da aplicação, eles
                    são um
                    <strong>atalho</strong>
                    para as informações do menu.
                  </p>
                  <p>Experimente e tenha uma boa navegação.</p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <botao
                estilo="cheio-verde"
                rotulo="Entendi"
                icone="ok-modal"
                dismiss="modal"
              ></botao>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="form">
      <div
        class="main-container container container-top"
        style="padding-bottom: 25px"
      >
        <div class="col-xs-12 hidden-xs hidden-sm card-group">
          <h2>Mais acessados</h2>
          <div v-for="rota of rotas" :key="rotas.indexOf(rota)">
            <div class="col-md-3 col-xs-6">
              <router-link :to="{ name: rota.name }">
                <div class="card card-servico">
                  <div class="card-content">
                    <h2>{{ rota.meta.titulo }}</h2>
                    <div class="row">
                      <div
                        class="col-md-12 col-sm-12"
                        style="text-align: center"
                      >
                        <img
                          :src="require(`../../assets/${rota.meta.imagem}`)"
                          :alt="rota.meta.titulo"
                        />
                        <div class="form-group" style="margin-top: 20px">
                          <label>
                            CONSULTAR&nbsp;
                            <i
                              class="fa fa-external-link fa-fw"
                              aria-hidden="true"
                            ></i>
                          </label>
                          <p class="hidden-xs">{{ rota.meta.texto }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-xs-12 hidden-md hidden-lg card-group">
          <div class="row row-group">
            <div class="col-md-3 col-xs-6">
              <router-link :to="{ name: rotas[0].name }">
                <div class="card card-servico">
                  <div class="card-content">
                    <h2>{{ rotas[0].meta.titulo }}</h2>
                    <div class="row">
                      <div
                        class="col-md-12 col-sm-12"
                        style="text-align: center"
                      >
                        <img
                          :src="require(`../../assets/${rotas[0].meta.imagem}`)"
                          :alt="rotas[0].meta.titulo"
                        />
                        <div class="form-group" style="margin-top: 20px">
                          <label>
                            CONSULTAR&nbsp;
                            <i
                              class="fa fa-external-link fa-fw"
                              aria-hidden="true"
                            ></i>
                          </label>
                          <p class="hidden-xs">{{ rotas[0].meta.texto }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-md-3 col-xs-6">
              <router-link :to="{ name: rotas[1].name }">
                <div class="card card-servico">
                  <div class="card-content">
                    <h2>{{ rotas[1].meta.titulo }}</h2>
                    <div class="row">
                      <div
                        class="col-md-12 col-sm-12"
                        style="text-align: center"
                      >
                        <img
                          :src="require(`../../assets/${rotas[1].meta.imagem}`)"
                          :alt="rotas[1].meta.titulo"
                        />
                        <div class="form-group" style="margin-top: 20px">
                          <label>
                            CONSULTAR&nbsp;
                            <i
                              class="fa fa-external-link fa-fw"
                              aria-hidden="true"
                            ></i>
                          </label>
                          <p class="hidden-xs">{{ rotas[1].meta.texto }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="row row-group">
            <div class="col-md-3 col-xs-6">
              <router-link :to="{ name: rotas[2].name }">
                <div class="card card-servico">
                  <div class="card-content">
                    <h2>{{ rotas[2].meta.titulo }}</h2>
                    <div class="row">
                      <div
                        class="col-md-12 col-sm-12"
                        style="text-align: center"
                      >
                        <img
                          :src="require(`../../assets/${rotas[2].meta.imagem}`)"
                          :alt="rotas[2].meta.titulo"
                        />
                        <div class="form-group" style="margin-top: 20px">
                          <label>
                            CONSULTAR&nbsp;
                            <i
                              class="fa fa-external-link fa-fw"
                              aria-hidden="true"
                            ></i>
                          </label>
                          <p class="hidden-xs">{{ rotas[2].meta.texto }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-md-3 col-xs-6">
              <router-link :to="{ name: rotas[3].name }">
                <div class="card card-servico">
                  <div class="card-content">
                    <h2>{{ rotas[3].meta.titulo }}</h2>
                    <div class="row">
                      <div
                        class="col-md-12 col-sm-12"
                        style="text-align: center"
                      >
                        <img
                          :src="require(`../../assets/${rotas[3].meta.imagem}`)"
                          :alt="rotas[3].meta.titulo"
                        />
                        <div class="form-group" style="margin-top: 20px">
                          <label>
                            CONSULTAR&nbsp;
                            <i
                              class="fa fa-external-link fa-fw"
                              aria-hidden="true"
                            ></i>
                          </label>
                          <p class="hidden-xs">{{ rotas[3].meta.texto }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Botao from '@/components/botao';
import RegistrosModal from './registros-modal';
import listaFuncionariosLogados from './listaFuncionariosLogados';
import usuarioLogadoMock from '../../../static/support/sample-data/usuarioLogado';
import api from '@/services/api';
import ErrorHelper from '@/helpers/ErrorHelper';

export default {
  name: 'Home',

  data() {
    return {
      apiErrors: null,
      rotas: [],
      favoritosDoLogado: {},
      autenticados: this.$store.state.usuarioLogado.funcionarios,
      niveisUors: [],
    };
  },
  computed: {
    funcionariosLogados() {
      return this.$store.state.usuarioLogado.funcionarios;
    },
  },
  watch: {
    funcionariosLogados(novo, antigo) {
      this.autenticados = novo;
    },
  },
  methods: {
    obtemFavoritosLogado() {
      const sshdLogado = this.$store.state.usuarioLogado.sshd;
      const favoritos = JSON.parse(localStorage.getItem('clicados'));
      this.favoritosDoLogado = favoritos.find(item => item.sshd === sshdLogado);
    },
    listaClicados() {
      // this.rotas = this.favoritosDoLogado.links.slice(0, 4);
      let links = this.favoritosDoLogado.links.filter(
        rota => rota.name !== 'DependenteCpf',
      );
      this.rotas = links.slice(0, 4);
    },
    async listaGraus() {
      try {
        const graus = await api.get('graus-parentescos');

        this.$store.commit('setGraus', graus);
      } catch (error) {
        error => {
          const mensagem = ErrorHelper.trataMensagem(error);
          this.$root.$refs.toastr.e(mensagem, 'Atenção');
        };
      }
    },
    registraAutenticados(autenticados) {
      this.$store.commit('setAutenticados', autenticados);
      this.$store.commit('setFuncionario', autenticados[0]);
      this.autenticados = autenticados;
    },
    mostraModalExplicacao() {
      if (this.favoritosDoLogado.links[0].cliques === 1)
        jQuery('#bemVindoModal').modal('show');
    },
    mostraModalRegistros() {
      if (this.autenticados && this.autenticados.length > 1)
        jQuery('#registrosModal').modal('show');
    },
    async fazRequisicoes() {
      if (!this.autenticados) {
        this.listaGraus();
        await listaFuncionariosLogados(this);
        this.mostraModalRegistros();
      }
    },
  },
  created() {
    this.obtemFavoritosLogado();
    this.listaClicados();
    this.fazRequisicoes();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  components: {
    Botao,
    RegistrosModal,
  },
};
</script>

<style scoped>
h2 {
  text-align: center;
  font-size: 20px;
}

img {
  height: 81px;
}

.mais-acessados {
  text-align: left;
  margin: 20px 0px 10px 20px;
  font-size: 25px;
}

.container {
  padding-left: 8px;
  padding-right: 8px;
}

.container-top {
  padding-top: 6px;
}

.card-group {
  border: none;
  padding: unset;
}

.card {
  overflow: visible;
  margin-top: 10px;
  margin-left: -7px;
  margin-right: -7px;
}

.card-default,
.card-servico {
  margin-bottom: 6px;
}

.card-servico:hover {
  box-shadow: 0 4px 5px 2px #e8e8e8, 0 2px 1px 1px #d8d8d8;
  transform: translateY(-4px);
}

.card-servico {
  background: #dae8d7 none repeat scroll 0 0;
  color: #00615c;
  margin-bottom: 20px;
  cursor: pointer;
  margin-bottom: 6px;
}

.row-group {
  padding: 0px 15px;
}

.form-group > a,
.form-group > a:visited {
  color: #697473;
}

.form-group > a:hover,
.form-group > a:focus {
  color: #a1be4d;
}

@media screen and (min-width: 400px) {
  h2 {
    font-size: 25px;
  }
}

@media screen and (min-width: 520px) {
  .container {
    padding-left: 15px;
    padding-right: 15px;
  }

  .container-top {
    padding-top: 20px;
  }

  .card {
    margin-left: 0px;
    margin-right: 0px;
  }

  .card-default,
  .card-servico {
    margin-bottom: 20px;
  }
}

@media screen and (min-width: 992px) {
  h2 {
    font-size: 30px;
  }

  .card-group {
    padding: 0px 15px 15px;
    border: 1px solid #dddddd;
    border-radius: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?3bb35dbd